import { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, Sparkles, CheckCircle } from 'lucide-react';
import { Input } from "../ui/input";
import { Button } from "../ui/button";

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setIsSubmitting(true);
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsSubmitting(false);
    setIsSubmitted(true);
    setEmail('');
  };

  return (
    <footer className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 bg-[#F2F4F0] border-t border-[#2E5C41]/10" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        {/* Newsletter Section */}
        <div className="max-w-xl mx-auto text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#2E5C41]/10 rounded-full mb-4">
            <Sparkles className="w-4 h-4 text-[#2E5C41]" strokeWidth={1.5} />
            <span className="text-xs font-medium text-[#2E5C41]">Newsletter</span>
          </div>
          
          <h3 className="font-cabinet text-xl md:text-2xl font-bold text-[#1A2E24] mb-3">
            ¿Aún no estás listo? Mantente informado
          </h3>
          <p className="text-sm text-[#4B5E53] mb-6">
            Recibe tips de IA para nutricionistas, casos de éxito y actualizaciones de HabitIA.
          </p>

          {!isSubmitted ? (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
              <Input
                type="email"
                placeholder="tu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 h-12 bg-white border-[#2E5C41]/20 focus:border-[#2E5C41] rounded-full px-5"
                data-testid="newsletter-email"
                required
              />
              <Button
                type="submit"
                disabled={isSubmitting}
                className="h-12 px-6 bg-[#2E5C41] hover:bg-[#1A2E24] text-white font-medium rounded-full"
                data-testid="newsletter-submit"
              >
                {isSubmitting ? (
                  <span className="flex items-center gap-2">
                    <motion.div
                      animate={{ rotate: 360 }}
                      transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                    >
                      <Send className="w-4 h-4" />
                    </motion.div>
                    Enviando...
                  </span>
                ) : (
                  <span className="flex items-center gap-2">
                    <Send className="w-4 h-4" strokeWidth={1.5} />
                    Suscribirme
                  </span>
                )}
              </Button>
            </form>
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="flex items-center justify-center gap-2 p-4 bg-[#2E5C41]/10 rounded-2xl"
            >
              <CheckCircle className="w-5 h-5 text-[#2E5C41]" strokeWidth={1.5} />
              <span className="text-[#2E5C41] font-medium">¡Gracias! Te mantendremos informado.</span>
            </motion.div>
          )}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#2E5C41]/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Logo */}
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-[#2E5C41] flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" strokeWidth={1.5} />
              </div>
              <span className="font-cabinet text-lg font-bold text-[#1A2E24]">
                Habit<span className="text-[#2E5C41]">IA</span>
              </span>
            </div>

            {/* Links */}
            <div className="flex items-center gap-6 text-sm text-[#4B5E53]">
              <a href="#" className="hover:text-[#2E5C41] transition-colors">Privacidad</a>
              <a href="#" className="hover:text-[#2E5C41] transition-colors">Términos</a>
              <a href="mailto:hola@habitia.app" className="hover:text-[#2E5C41] transition-colors">Contacto</a>
            </div>

            {/* Copyright */}
            <div className="text-xs text-[#4B5E53] flex flex-col sm:flex-row gap-1 sm:gap-4 md:items-center">
              <p>© 2025 HabitIA. Todos los derechos reservados.</p>
              <p className="font-medium text-[#2E5C41]">Owned by Future Ventures Group LLC</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
